import isPrimitive from './isPrimitive';

/**
 * a deep comparison helper for objects
 * typed params as any, this follows DefinitelyTyped's lodash isEqual TS
 * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/lodash/fp.d.ts#L659-L665
 *
 * @param obj1
 * @param obj2
 * @returns
 */
export default function isEqual(obj1, obj2) {
  // it's just the same object. No need to compare.
  if (obj1 === obj2) {
    return true;
  }

  // compare primitives
  if (isPrimitive(obj1) || isPrimitive(obj2)) {
    return obj1 === obj2;
  }
  if (typeof obj1 === 'function' && typeof obj2 === 'function') {
    return false;
  }
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  // compare objects with same number of keys
  for (var key in obj1) {
    //other object doesn't have this prop
    if (!(key in obj2)) {
      return false;
    }
    if (!isEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/isEqual.js
// module id = 2604
// module chunks = 11